var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.952267 7.95227H6.04773V13.0477C6.04773 13.5656 6.47375 14 7 14C7.52625 14 7.95227 13.5656 7.95227 13.0477V7.95227H13.0477C13.5656 7.95227 14 7.52625 14 7C14 6.47375 13.5656 6.04773 13.0477 6.04773H7.95227V0.952267C7.95227 0.434368 7.52625 0 7 0C6.47375 0 6.04773 0.434368 6.04773 0.952267V6.04773H0.952267C0.434368 6.04773 0 6.47375 0 7C0 7.52625 0.434368 7.95227 0.952267 7.95227Z","fill":"currentColor"}));
}

PlusInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
